import DOMPurify from 'dompurify'
import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate, useParams } from 'react-router-dom'
import { ArticleDetailType, BoardConfigType } from '../../@types/board'
import { getArticleDetail, getBoardConfiguration } from '../../api/board'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

export default function FaqView() {
  const [item, setItem] = useState<ArticleDetailType>()
  const [boardCon, setBoardCon] = useState<BoardConfigType[]>([])
  const [boardNo, setBoardNo] = useState<number>()
  const params = useParams()
  const { setIsLottie } = useCommonContext()
  const { isAppView } = useAppContext()

  const navigate = useNavigate()

  useEffect(() => {
    getBoardConfiguration().then((res) => {
      setBoardCon(res.data.boardConfigs)
    })
  }, [])

  useEffect(() => {
    if (boardCon) {
      const faqBoard = boardCon.find((el: any) => el.boardId === 'faq')
      if (faqBoard) {
        setBoardNo(faqBoard.boardNo)
      }
    }
  }, [boardCon])
  useEffect(() => {
    if (boardNo) {
      //@ts-ignore
      getArticleDetail(boardNo, params.id).then((res) => {
        setItem(res.data)
        setIsLottie(false)
      })
    }
  }, [boardNo])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>자주 묻는 질문</PageTitle>
            <hr />
            <div className='faq_view'>
              <div className='title'>
                <p>{item?.title}</p>
                <span className='date'>
                  {item?.registerYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}
                </span>
              </div>
              <div className='content'>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.content || '') }}></div>
              </div>
              <button
                className='btn_go_list'
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.goBack)
                  } else {
                    navigate(-1)
                  }
                }}
              >
                목록 보기
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
